export const metricNumber = value => {
  if (value === null || value === undefined || value === '' || typeof value === 'boolean') return null;
  if (typeof value !== 'number' && typeof value !== 'string') return null;
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
};

export const aiBenchmark = report => {
  const raw = report?.industry_benchmark;
  return {
    avg: metricNumber(typeof raw === 'object' && raw ? (raw.avg ?? raw.average) : raw),
    top: metricNumber((typeof raw === 'object' && raw ? (raw.top ?? raw.top_performer) : null) ?? report?.top_performer_score),
  };
};

export const gapText = (score, benchmark, plus = false) => {
  const left = metricNumber(score), right = metricNumber(benchmark);
  if (left === null || right === null) return 'Not available';
  const difference = left - right;
  return `${plus && difference > 0 ? '+' : ''}${difference.toFixed(2)}`;
};